var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotification = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 19.483h20.5v-3.298l-1.414-1.887V9.007C21.086 4.04 17.129 0 12.263 0 7.397 0 3.44 4.04 3.44 9.007v5.291L2 16.218v3.265Zm19.008-1.516H3.492v-1.232l1.44-1.92V9.007c0-4.126 3.29-7.484 7.331-7.484 4.042 0 7.33 3.358 7.33 7.484v5.808l1.415 1.887v1.265Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.198 22.45a2.08 2.08 0 0 0 1.985-1.51v-.006h1.557a1.063 1.063 0 0 1-.013.07c-.005.022-.01.046-.013.069C15.37 22.768 13.982 24 12.198 24s-3.263-1.325-3.542-3.06h1.557c.26.874 1.064 1.51 1.985 1.51Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Notification.17ede60094cc7abcf905e5cd13ebe9df.svg";